import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  blockIcon: {
    id: 'studio.Tc5BiV',
    defaultMessage: 'Block icon',
  },
  error: {
    id: 'studio.2Ppkru',
    defaultMessage: 'Something went wrong when fetching this block.',
  },
  sourceCode: {
    id: 'studio.GAUX9p',
    defaultMessage: 'Source code',
  },
});
